import { configureStore } from '@reduxjs/toolkit';
import timerReducer from './slices/timerSlice';
import activityReducer from './slices/activitySlice';
import configReducer from './slices/configSlice';
import bulkReducer from './slices/bulkSlice';
import globalReducer from './slices/globalSlice';
import paymentReducer from './slices/paymentSlice';
import projectReducer from './slices/projectSlice';
import reportReducer from './slices/reportSlice';
import todoListReducer from './slices/todoListSlice';
import userReducer from './slices/userSlice';
import webPushReducer from './slices/webPushSlice';
export const store = configureStore({
    reducer: {
        timer: timerReducer,
        activity: activityReducer,
        config: configReducer,
        bulk: bulkReducer,
        global: globalReducer,
        payment: paymentReducer,
        project: projectReducer,
        report: reportReducer,
        todoList: todoListReducer,
        user: userReducer,
        webPush: webPushReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: ['persist/PERSIST'],
            ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
            ignoredPaths: ['items.dates'],
        },
        immutableCheck: {
            warnAfter: 32,
        },
    }),
    devTools: process.env.NODE_ENV !== 'production' && {
        actionsDenylist: ['timer/reduceSeconds'],
        maxAge: 50,
        trace: false,
    },
});
